import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
  ResponsiveContainer,
} from 'recharts';
import { LCC_CONSTANTS } from '@lcc/shared';
import { format } from 'date-fns';

interface DataPoint {
  date: string;
  cpl: number;
  spend: number;
  leads: number;
  zone: string | null;
}

interface Props {
  data: DataPoint[];
}

export function CplTrendChart({ data }: Props) {
  const formatted = data.map((d) => ({
    ...d,
    dateLabel: format(new Date(d.date), 'dd MMM'),
  }));

  return (
    <ResponsiveContainer width="100%" height={200}>
      <LineChart data={formatted} margin={{ top: 5, right: 10, left: -10, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis dataKey="dateLabel" tick={{ fontSize: 11, fontFamily: 'Jost' }} />
        <YAxis tick={{ fontSize: 11, fontFamily: 'JetBrains Mono' }} tickFormatter={(v: number) => `£${v}`} />
        <Tooltip
          formatter={(value: number) => [`£${value.toFixed(2)}`, 'CPL']}
          contentStyle={{ fontFamily: 'Jost', fontSize: 12, border: '1px solid #e5e7eb' }}
        />

        {/* Zone reference lines */}
        <ReferenceLine y={LCC_CONSTANTS.CPL_GREEN_MAX} stroke="#4A7C2A" strokeDasharray="4 2" label={{ value: 'Green', position: 'right', fontSize: 10 }} />
        <ReferenceLine y={LCC_CONSTANTS.CPL_YELLOW_MAX} stroke="#B07F1A" strokeDasharray="4 2" label={{ value: 'Yellow', position: 'right', fontSize: 10 }} />
        <ReferenceLine y={LCC_CONSTANTS.CPL_ORANGE_MAX} stroke="#B85420" strokeDasharray="4 2" label={{ value: 'Red', position: 'right', fontSize: 10 }} />

        <Line
          type="monotone"
          dataKey="cpl"
          stroke="#1A2E44"
          strokeWidth={2}
          dot={{ r: 3, fill: '#1A2E44' }}
          activeDot={{ r: 5 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
